import { render, staticRenderFns } from "./TripChangelog.vue?vue&type=template&id=67f3dd77&scoped=true&"
import script from "./TripChangelog.vue?vue&type=script&lang=js&"
export * from "./TripChangelog.vue?vue&type=script&lang=js&"
import style0 from "./TripChangelog.vue?vue&type=style&index=0&id=67f3dd77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f3dd77",
  null
  
)

/* custom blocks */
import block0 from "./TripChangelog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports